{
    "ChartstyleoptionsPie2d": "Torta (2D)",
    "ChartstyleoptionsPie3d": "Torta (3D)",
    "ChartstyleoptionsDoughnut2d": "Ciambella (2D)",
    "ChartstyleoptionsDoughnut3d": "Ciambella (3D)",
    "ChartstyleoptionsLine": "Linea",
    "ChartstyleoptionsArea": "Area",
    "ChartstyleoptionsAreastacked": "Area (impilata)",
    "ChartstyleoptionsRadarpolararea": "Radar (area polare)",
    "ChartstyleoptionsColumn2d": "Colonna (2D)",
    "ChartstyleoptionsColumn2dstacked": "Colonna (2D, impilata)",
    "ChartstyleoptionsColumn3d": "Colonna (3D)",
    "ChartstyleoptionsColumn3dstacked": "Colonna (3D, impilata)",
    "ChartstyleoptionsBar2d": "Barra (2D)",
    "ChartstyleoptionsBar2dstacked": "Barra (2D, impilata)",
    "ChartstyleoptionsBar3d": "Bar (3D)",
    "ChartstyleoptionsBar3dstacked": "Bar (3D, impilato)",
    "NAME": "ChartStyleOptions"
}